/*
 *  Questo component è un'alternativa a generic-view-attachments
 *  ma di fatto contiene solo l'accordion 
 *  e la gestione degli allegati è in un altro component
 * 
 *  Lo scopo è:
 *  - avere l'accordion staccato dal gestore allegati
 *  - in modo tale da poter inserire errori e loading vari
 *  - e in caso non serva l'accordion
 * 
 */ 

import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import { AttachmentsBlocksList, GenericAttachedFile} from '@shared/components/view-files/models/attachments-interface';
import {Utilities as U} from '@shared/utilities/utilities.model';
import {UploadFileService} from '@shared/service/upload-file.service';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import { BookingFlowService } from 'app/bookings/services/booking-flow.service';
import { logger } from '@app/shared/utilities/logger.model';
import { AuthorityTemporaryAttachmentsAdapter, AuthorityTemporaryAttachmentsErrorModel, AuthorityTemporaryAttachmentsWarningModel } from '@app/authority/authority-shared/adapters/AuthorityAttachmentsAdapter';
import { InPageMessage, InPageMessageSize, InPageMessageType } from '@app/shared/components/in-page-message/in-page-message.component';
import { MessageManagerService } from '@app/shared/service/message-manager/message-manager.service';
import { ErrorResponse } from '@app/shared/models/error-response.model';


@Component({
	selector: 'amd-attachments-viewver',
	templateUrl: './attachments-viewver.component.html',
	styleUrls: ['./attachments-viewver.component.scss']
})
export class AttachmentsViewerComponent implements OnInit, OnChanges {
	@ContentChild('attachmentGlobalActions') attachmentGlobalActions: TemplateRef<any>;
	@ContentChild('addFile') addFile: TemplateRef<any>;
	@Input() translateContext: TranslateContext;
	@Input() attachmentList: AttachmentsBlocksList | AuthorityTemporaryAttachmentsAdapter;
	@Input() canAddFile: boolean;
	@Input() canEdit: boolean;
	@Input() canDelete?: boolean;
	@Input() zipFileName: string = 'ZIP';
	@Input() isReadonly?: boolean;
	@Input() isLazyLoadingAccordion?: boolean;
	@Input() isLoaderVisible?: boolean = false;
	// callback
	@Input() actionOnZipClick?: (files: GenericAttachedFile[]) => void;
	@Input() actionOnDownloadFilesClick?: (files: GenericAttachedFile[]) => void;
	@Input() callbackUploadFile?: Function;
	@Input() onAccordionOpen?: Function;
	@Input() onFirstAccordionOpen?: Function;
	@Output() uploadFileEventEmitter: EventEmitter<void> = new EventEmitter<void>();


	sharedTranslateContext: TranslateContext = TranslateContext.SHARED;
	accordionExpanded: boolean = false; 
	isFirstAccordionOpen: boolean = false; 
	messages: InPageMessage[] = [];
	isErrorState: boolean = false;

	constructor(
		public uploadFileService: UploadFileService,
		public messageManagerService: MessageManagerService,
	) {
	}
	
	ngOnInit(): void {	
	}
	
	ngOnChanges(changes: SimpleChanges): void {	
		
		if (
			!U.isEmpty(changes.attachmentList) && 
			!U.isEmpty(changes.attachmentList.currentValue)
		) {

			// TOOD
			// sarebbe meglio separare gli errori dalla lista allegati
			const warnings = changes.attachmentList.currentValue.warnings;
			const errors = changes.attachmentList.currentValue.errors;

			const getMessage__fn = async (msg: string, type: InPageMessageType) => {
				this.messages.push({ size: InPageMessageSize.SMALL, type: type, text: msg });
			};

			// ['warnings', 'errors'].map(x => !U.isEmpty(resAdapter[x]) && resAdapter[x].map(y => getMessage__fn(y)));
			!U.isEmpty(warnings) && warnings.map(x => getMessage__fn(x.getMessage(), InPageMessageType.WARNING));
			!U.isEmpty(errors)   && errors.map(x => getMessage__fn(x.getMessage(), InPageMessageType.ERROR));
		}
	}	

	uploadFileEventListener(): void {
		this.callbackUploadFile && this.callbackUploadFile();
	}

	closeLoader(): void {
		this.isLoaderVisible = false;
	}

	/**
	 * CO 7055
	 * solo per cristalli, se non ci sono allegati
	 * potrebbero essere temporaneamente salvati in un'altra posizione
	 */
	async onAccordionOpenedListener(): Promise<void> {

		try {
				
			// MOCK
			// per testare il listener ogni volta che si apre l'accordion
			if (!this.accordionExpanded) { 

				// l'accordion si apre subito e mostra il loading
				// nel caso in cui ci sia la callback
				this.accordionExpanded = !this.accordionExpanded;

				// questa callback viene chiamata solo la prima volta
				// e subito dopo verrà eseguita anche quella associata all'apertura dell'accordion 
				// (ad ogni apertura)
				// ma il loading sarà visibile soltanto per la prima apertura

				if (!this.isFirstAccordionOpen) {
					this.isFirstAccordionOpen = true;
					
					// se non esiste la callback esce subito dal flusso
					if (U.isEmpty(this.onFirstAccordionOpen)) {
						this.closeLoader();
						return;
					}

					const promise: Promise<any> = this.onFirstAccordionOpen();
					
					if (U.isEmpty(promise)) {
						this.closeLoader();
						const errorMessage = 'Error in onAccordionOpenedListener() - promise is empty';
						logger.error();
						this.messages.push({ size: InPageMessageSize.SMALL, type: InPageMessageType.ERROR, text: errorMessage });
						return;
					}
					
					promise
						.then(_ =>  this.closeLoader())
						.catch(e => {
							logger.error('Error in onAccordionOpenedListener() -', e);
							this.closeLoader();
							this.isErrorState = true;
							this.attachmentList.attachmentsBlocks = [];

							let message = '';
							
							if (e instanceof ErrorResponse && e.error && e.message) {
								message = e.getMessageTranslated('authority');
							} else {
								message = e.message;
							}
						
							this.messages.push({ size: InPageMessageSize.SMALL, type: InPageMessageType.ERROR, text: message });
						});
				}

				!U.isEmpty(this.onAccordionOpen) && this.onAccordionOpen();
				return;
			}
	
		} catch (e) {
			this.closeLoader();
			logger.error('Error in onAccordionOpenedListener() - ', e);
			this.messages.push({ size: InPageMessageSize.SMALL, type: InPageMessageType.ERROR, text: e.message });
		}
		
		// va cambiato stato anche quando si chiude
		this.accordionExpanded = !this.accordionExpanded;
	}		
}
